import React from 'react';
import Localize from 'react-intl-universal';

import { Field } from 'formik';

import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

const StyledGridItem = styled(Grid)(() => ({
  marginBottom: '0.8rem',
  '&.MuiGrid-root': {
    paddingTop: '0.1rem'
  }
}));

const CreateFieldsForArrayFromConfig = ({
  config = {},
  setFieldValue = () => {},
  optionsObj = {},
  handleFields = () => {},
  arrayIndex = '',
  fieldsArrayName = ''
}) => {
  return (
    <>
      {config.map((field) => {
        const inner = handleFields?.[field?.name] || (() => {});
        const isIcon = field.isIcon ? { isIcon: field.isIcon } : {};
        return (
          <StyledGridItem item xs={12} md={6} key={field?.name} sx={field.style || {}}>
            <FormControl fullWidth margin='normal'>
              <Field
                name={`${fieldsArrayName}.${arrayIndex}.${field.name}`}
                label={`${Localize.get(field.label)}`}
                component={field.component}
                options={optionsObj[field.options] || []}
                {...inner(setFieldValue)}
                {...isIcon}
              />
            </FormControl>
          </StyledGridItem>
        );
      })}
    </>
  );
};
export default CreateFieldsForArrayFromConfig;
